import request from '../../utils/request'

export default {
  downloadTemplate: data => request({
    url: '/api/services/app/FinanceReportDataImport/DownloadTemplate',
    method: 'get',
    params: data
  }),
}
